import FetchByObjectConfig from '../Helpers/FetchByObjectConfig';

export const getNotificationsRequest = ({page, perPage}) => {
    const config = {
        path: `notifications?page=${page}&per_page=${perPage}`,
        method: 'GET',
    };
    return FetchByObjectConfig(config);
}

export const updateSeenNotificationRequest = (notificationId) => {
    const config = {
        path: `notifications/${notificationId}/seen`,
        method: 'PUT',
    };
    return FetchByObjectConfig(config);
}
